import React from 'react';
import PropTypes from 'prop-types';

const VoiceSquare = ({ className, progress }) => {
  const radius = 15;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (circumference * progress);  // Adjust strokeDashoffset based on progress

  return (
    <div className="relative flex items-center justify-center">
      <svg
        className="absolute"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        xmlns="http://www.w3.org/2000/svg"
        style={{ transform: 'rotate(-90deg)' }}  // Rotate the circle to start from the top
      >
        <circle
          cx="20"
          cy="20"
          r={radius}
          stroke="#CCAA60"
          strokeWidth="2"
          fill="none"
        />
        <circle
          cx="20"
          cy="20"
          r={radius}
          stroke="white"
          strokeWidth="2"
          fill="none"
          strokeDasharray={circumference}  // Full circumference of the circle
          // strokeDashoffset={strokeDashoffset}  // Dynamic offset based on progress
          strokeDashoffset={isNaN(progress) ? 0 : progress * 2 * Math.PI}
          strokeLinecap="round"
        />
      </svg>

      {/* VoiceSquare Icon */}
      <a href="#" className="flex items-center justify-center rounded-full bg-gold-200 md:h-11 md:w-11 h-9 w-9">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 21"
          xmlns="http://www.w3.org/2000/svg"
          className={`fill-current ${className}`}
          fill="currentColor"
        >
          <path
            d="M3.3335 7.84424V12.6109"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.66699 6.25537V14.1887"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 4.6665V15.7776"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.3335 6.25537V14.1887"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.667 7.84424V12.6109"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </a>
    </div>
  );
};

VoiceSquare.propTypes = {
  className: PropTypes.string,
  progress: PropTypes.number.isRequired,  // Audio progress (0 to 1)
};

VoiceSquare.defaultProps = {
  className: '',  // Default to an empty string
};

export default VoiceSquare;
